import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../Assets/Imgs/Logo.svg'

const LogoLink = () => {
    return ( 
        <Link to='/'>
            <img src={Logo} alt="" />
        </Link>
     );
}
 
export default LogoLink;